import rest from '@modules/rest'
import { mapHandicapInput } from '@convenia/employee-organisms/SystemFields/Personal/content/mappers/handicap'

export const getHandicap = async (params) => {
  try {
    const { employeeId, companyId } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/handicapped/admission`

    const { data } = await rest.get(url)

    return [ null, data ]
  } catch (err) {
    return [ err, null ]
  }
}

export const updateHandicap = async (data, params) => {
  try {
    const { employeeId, companyId, schema } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/handicapped/admission`
    const body = mapHandicapInput({ data, schema, })

    const response = await rest.post(url, { body })

    return [ null, response?.data ]
  } catch (err) {
    return [ err, null ]
  }
}

export const deleteHandicap = async (params) => {
  try {
    const { employeeId, companyId } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/handicapped/admission`

    await rest.delete(url)

    return [ null, true ]
  } catch (err) {
    return [ err, null ]
  }
}
